/**
 * save cookie
 */

export function save_cookie() {
  /**
   * 言語ボタンでCookieを保存
   * WP配下に置くと、WP配下にしかcookieが保存できないので、
   */
  document.addEventListener('DOMContentLoaded', function() {

    // 初回の言語設定（ページ読み込み時）
    if (window.location.pathname.includes('english/product/technical')) {
      document.cookie = 'lang=en; path=/';
    } else {
      document.cookie = 'lang=ja; path=/';
    }

    // ボタンを取得
    var langJpButton = document.getElementById('lang_ja');
    var langEnButton = document.getElementById('lang_en');

    if ( !langJpButton || !langEnButton ) {
      return false;
    }

    // lang_jaボタンがクリックされたときの処理
    langJpButton.addEventListener('click', function() {
      // 現在のURLに含まれるクエリパラメーターを取得
      var queryParams = window.location.search;

      // Cookieに"lang=ja"という値を保存する
      document.cookie = 'lang=ja; path=/';

      // lang_jpボタンがクリックされたので、lang_enボタンのクッキーを削除する
      // document.cookie = 'lang=en=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

      // 日本語ページにリダイレクトする
      var currentHostname = window.location.hostname;
      window.location.href = 'https://' + currentHostname + removeLanguageParameterFromURL( window.location.pathname ) + queryParams;

      // ページをリロードする
      // location.reload();
    });

    // lang_enボタンがクリックされたときの処理
    langEnButton.addEventListener('click', function() {
      // 現在のURLに含まれるクエリパラメーターを取得
      var queryParams = window.location.search;

      // Cookieに"lang=en"という値を保存する
      document.cookie = 'lang=en; path=/';

      // lang_enボタンがクリックされたので、lang_jpボタンのクッキーを削除する
      // document.cookie = 'lang=ja=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

      // 英語ページにリダイレクトする
      var currentHostname = window.location.hostname;
      window.location.href = 'https://' + currentHostname + '/english' + removeLanguageParameterFromURL( window.location.pathname ) + queryParams;

      // ページをリロードする
      // location.reload();
    });

    // 言語パラメーターをURLから取り除く関数
    function removeLanguageParameterFromURL(path) {
      // URLから言語パラメーター（/english/ や /ja/ など）を取り除いたパスを返す
      var languagePattern = /(\/english\/|\/ja\/)/;
      return path.replace(languagePattern, '/');
    }
  });
}
